export const Monogram = ({ size = 40, stroke = "rgba(212,175,55,0.55)" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-label="SD monogram">
    <rect x="2" y="2" width="60" height="60" rx="30" stroke={stroke} strokeWidth="1.4" />
    <text x="32" y="41" textAnchor="middle" fontFamily="Cormorant Garamond, Georgia, serif" fontSize="26" fontWeight="600" fill="#D4AF37" letterSpacing="1.5">SD</text>
  </svg>
);

export const Tassel = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 90 320" fill="none" aria-hidden="true">
    <path d="M45 0 V60" stroke="#AA771C" strokeWidth="3" />
    <path d="M45 0 V60" stroke="#F3E5AB" strokeWidth="1" strokeDasharray="2 5" />
    <circle cx="45" cy="74" r="14" fill="url(#tasselGold)" stroke="#8a6a1f" strokeWidth="1" />
    <circle cx="45" cy="74" r="7" fill="#0B132B" opacity="0.85" />
    <path d="M36 86 Q45 96 54 86 L60 250 Q45 268 30 250 Z" fill="url(#tasselGold)" />
    <g stroke="#8a6a1f" strokeWidth="1" opacity="0.5">
      <path d="M37 95 L33 245" /><path d="M41 98 L39 252" /><path d="M45 99 L45 254" />
      <path d="M49 98 L51 252" /><path d="M53 95 L57 245" />
    </g>
    <defs>
      <linearGradient id="tasselGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFE8A3" />
        <stop offset="45%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#996515" />
      </linearGradient>
    </defs>
  </svg>
);

export const Flourish = ({ className = "", flip = false }) => (
  <svg className={className} viewBox="0 0 220 70" fill="none" aria-hidden="true" style={flip ? { transform: "scaleX(-1)" } : undefined}>
    <path d="M8 58 Q 80 8 212 22" stroke="url(#flGold)" strokeWidth="1.4" fill="none" />
    <g fill="url(#flGold)">
      <ellipse cx="34" cy="42" rx="12" ry="4.6" transform="rotate(-32 34 42)" />
      <ellipse cx="60" cy="28" rx="12" ry="4.6" transform="rotate(-24 60 28)" />
      <ellipse cx="88" cy="20" rx="12" ry="4.6" transform="rotate(-14 88 20)" />
      <ellipse cx="118" cy="17" rx="12" ry="4.6" transform="rotate(-6 118 17)" />
      <ellipse cx="148" cy="17" rx="12" ry="4.6" transform="rotate(4 148 17)" />
      <ellipse cx="176" cy="19" rx="11" ry="4.2" transform="rotate(12 176 19)" />
      <circle cx="212" cy="22" r="4" />
      <circle cx="12" cy="58" r="2.6" />
    </g>
    <defs>
      <linearGradient id="flGold" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#996515" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F3E5AB" />
      </linearGradient>
    </defs>
  </svg>
);

export const GoldRule = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
    <span className="hairline-gold w-20 sm:w-32" />
    <svg width="14" height="14" viewBox="0 0 14 14" fill="#D4AF37"><path d="M7 0 L8.8 5.2 L14 7 L8.8 8.8 L7 14 L5.2 8.8 L0 7 L5.2 5.2 Z" /></svg>
    <span className="hairline-gold w-20 sm:w-32" />
  </div>
);

export const DoctoralTam = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 120 380" fill="none" aria-hidden="true" data-testid="doctoral-tam">
    <defs>
      <linearGradient id="tamVelvet" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1C3050" />
        <stop offset="55%" stopColor="#0E1E38" />
        <stop offset="100%" stopColor="#081226" />
      </linearGradient>
      <linearGradient id="tamGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFE8A3" />
        <stop offset="45%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#996515" />
      </linearGradient>
    </defs>
    <path d="M60 0 V22" stroke="#AA771C" strokeWidth="2.5" />
    <path d="M14 52 Q14 86 60 92 Q106 86 106 52 Q106 26 60 24 Q14 26 14 52 Z" fill="url(#tamVelvet)" />
    <ellipse cx="60" cy="46" rx="42" ry="16" fill="url(#tamVelvet)" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="1.2" />
    <path d="M28 40 Q30 70 42 84" stroke="#1E3A66" strokeWidth="1" opacity="0.8" />
    <path d="M92 40 Q90 70 78 84" stroke="#1E3A66" strokeWidth="1" opacity="0.8" />
    <circle cx="60" cy="44" r="4.5" fill="url(#tamGold)" />
    <path d="M60 46 Q68 120 64 176" stroke="url(#tamGold)" strokeWidth="3" fill="none" />
    <path d="M56 176 Q64 184 72 176 L78 268 Q64 286 50 268 Z" fill="url(#tamGold)" opacity="0.95" />
    <g stroke="#8a6a1f" strokeWidth="1" opacity="0.5">
      <path d="M58 184 L54 262" />
      <path d="M64 186 L64 266" />
      <path d="M70 184 L74 262" />
    </g>
    <circle cx="64" cy="300" r="30" fill="url(#tamGold)" />
    <circle cx="64" cy="300" r="24" fill="#0B132B" />
    <text x="64" y="306" textAnchor="middle" fontFamily="Cormorant Garamond, Georgia, serif" fontSize="17" fontWeight="700" fill="#D4AF37" letterSpacing="1">FIU</text>
  </svg>
);
